export default __webpack_public_path__ + "static/media/missing_image.7ae6cf0c.svg";